var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWindowRestore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-window-restore",
    "data-name": "Icon awesome-window-restore",
    d: "M10,.938V6.563a.938.938,0,0,1-.937.937H8.125V3.438A1.565,1.565,0,0,0,6.563,1.875H2.5V.938A.938.938,0,0,1,3.438,0H9.063A.938.938,0,0,1,10,.938Zm-2.5,2.5V9.063A.938.938,0,0,1,6.563,10H.938A.938.938,0,0,1,0,9.063V3.438A.938.938,0,0,1,.938,2.5H6.563A.938.938,0,0,1,7.5,3.438Zm-1.328.547a.235.235,0,0,0-.234-.234H1.484a.235.235,0,0,0-.234.234V5H6.172Z",
    fill: "#a6a6a6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowRestore);
export default __webpack_public_path__ + "static/media/window-restore.945862f264dbc8b69ca8c6283237cbe6.svg";
export { ForwardRef as ReactComponent };